import useBreadcrumbs from 'src/hooks/useBreadcrumbs';
import BreadcrumbSkeleton from './BreadcrumbSkeleton';
import BasicBreadcrumbs from './Breadcrumbs';

interface IProps {
  pageId: string;
  breadcrumbsCount?: number;
}
export const DynamicBreadcrumbs = (props: IProps) => {
  const { pageId, breadcrumbsCount } = props;
  const {
    breadcrumbs: dynamicBreadcrumbs,
    isLoading: isBreadcrumbDataLoading,
  } = useBreadcrumbs(pageId);

  // +1 to show the home page in the breadcrumbs
  const breadcrumbsToShow = breadcrumbsCount ? breadcrumbsCount + 1 : 2;

  return (
    <>
      {!isBreadcrumbDataLoading && (
        <BasicBreadcrumbs breadcrumbs={dynamicBreadcrumbs || []} />
      )}
      {isBreadcrumbDataLoading && (
        <BreadcrumbSkeleton count={breadcrumbsToShow} />
      )}
    </>
  );
};

export default DynamicBreadcrumbs;
